import { PRODUCTS, getProduct } from "./products";

//—— 首頁內容（示範資料）——
//
//  之後接後端時，把這支換成 API 回傳即可 —— 各元件吃的都是這裡的資料形狀，
//  所以只要後端照這個結構回，前端一行都不用改。
//
//  cover 是「用 CSS 畫的封面」而非圖檔：
//    theme  決定漸層配色（見 product-card-style.css 的 .pc-cover--*）
//    glyph  封面上的大字
//  等美術給圖之後，把 cover 換成 { image: "..." }，product-card 已經預留判斷。

//暫時不上首頁輪播的產品（填 code）。
//
//  liunian-panguan（判官）：他的 path 是 /product/liunian-panguan，但
//  App.js 裡**沒有**那條 route，也沒有 catch-all —— 輪播點下去是一片白頁。
//  （products.js 裡伏爻子那段記著同一個坑，他原本就是這樣壞的。）
//  那條 route 補上之後，把 code 從這個陣列移掉就會自己回到輪播裡。
//
//  用「排除清單」而不是直接去 products.js 刪掉那一筆：那份是全站共用的
//  真相（排行、分類、搜尋、評價卡都讀它），為了首頁動它會連帶影響別頁。
const HERO_HIDDEN = ["liunian-panguan"];

//首頁輪播
//  五位角色本人（扣掉 HERO_HIDDEN）。欄位形狀和原本一樣，只是多了 image ——
//  輪播元件有圖用圖、沒圖退回漸層大字，所以之後補上其他產品也不會壞。
//
//  資料本體在 constant/products；這裡只做「輪播要怎麼呈現它們」的轉換，
//  改文案改價格都回 products.js 一處改就好。
export const HERO_SLIDES = PRODUCTS.filter(
  (p) => !HERO_HIDDEN.includes(p.code),
).map((p) => ({
  id: p.id,
  glyph: p.glyph,
  theme: p.theme,
  image: p.image,
  //給輪播預載用（見 hero-carousel）。沒有的產品就不預載
  intro: p.intro,
  tag: p.persona.craft,
  title: p.persona.name,
  subtitle: p.subtitle,
  path: p.path,
}));

//卡片列要用的產品摘要
//  只取 ProductCard 吃得到的欄位。title 放角色名、badge 放術種 ——
//  卡片上真正要被記住的是「誰」，術種當小標記就夠了；
//  兩個都塞進標題會擠成兩行、再被 truncate 切掉，誰也看不清楚。
const toCard = (code) => {
  const p = getProduct(code);
  if (!p) return null;

  return {
    id: p.id,
    glyph: p.glyph,
    theme: p.theme,
    image: p.image,
    title: p.persona.name,
    subtitle: p.subtitle,
    badge: p.persona.craft,
    path: p.path,
  };
};

//熱門體驗
//  判官（liunian-panguan）先撤下來換成伏爻子（Kevin 2026-10-20）。
//
//  ⚠️ 判官的 path 是 /product/liunian-panguan，但 App.js 裡**沒有**那個
//  route，也沒有 catch-all —— 首頁第一排那張卡點下去是一片白頁。
//  （products.js 裡伏爻子那段也記著同一個坑，他原本就是這樣壞的。）
//  所以判官要回到首頁之前，得先有那條 route。
//
//  伏爻子的 path 是 /ask，直接進問卦聊天室，是現在按下去就能用的。
export const HOT_PRODUCTS = ["bazi-baiye", "ziwei-jingyue", "liuyao-fuyaozi"]
  .map(toCard)
  .filter(Boolean);

//戀愛主題
export const LOVE_PRODUCTS = ["match-feihong"].map(toCard).filter(Boolean);
